/* eslint-disable class-methods-use-this */
import {
    post,
    get,
    put,
    _delete,
  } from '@/lin/plugins/axios'
  
  const _baseUri = 'plugin/project/project/'
  
  class Project {
    // constructor() {}
    async add(info) {
      const res = await post(`${_baseUri}`, info)
      return res
    }
  
    async get(id) {
      const res = await get(`${_baseUri}${id}`)
      return res
    }

    async getFeature(id) {
      const data = {
        id,
      }
      const res = await get(`${_baseUri}feature/gets/`, data)
      return res
    }

    async getFeatureSetting(id, feature) {
      const data = {
        id,
        feature,
      }
      const res = await get(`${_baseUri}feature/setting`, data)
      return res
    }

    async setFeatureSetting(id, feature, setting) {
      const data = {
        id,
        feature,
        setting,
      }
      const res = await put(`${_baseUri}feature/setting`, data)
      return res
    }

    async addFeature(id, feature) {
      const data = {
        id,
        feature,
      }
      const res = await put(`${_baseUri}feature/add/`, data)
      return res
    }

    async removeFeature(id, feature) {
      const data = {
        id,
        feature,
      }
      const res = await put(`${_baseUri}feature/remove/`, data)
      return res
    }
  
    async edit(id, info) {
      const res = await put(`${_baseUri}${id}`, info)
      return res
    }
  
    async delete(id) {
      const res = await _delete(`${_baseUri}${id}`)
      return res
    }
  
    async gets(pageInfo) {
      const res = await get(`${_baseUri}`, pageInfo)
      return res
    }

    async updatePublish(id, info) {
      const data = {
        published: info.published,
      }
      const res = await put(`${_baseUri}publish/${id}/`, data)
      return res
    }
  }
  
  export default new Project()
  